import _classCallCheck from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/www/annaschreider.com/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// https://github.com/davidtheclark/react-displace/blob/master/src/displace.js
import React from "react";
import ReactDOM from "react-dom";
export function displace(WrappedComponent, optionalOptions) {
  var options = optionalOptions || {};

  var Displaced = /*#__PURE__*/function (_React$Component) {
    _inherits(Displaced, _React$Component);

    var _super = _createSuper(Displaced);

    function Displaced() {
      _classCallCheck(this, Displaced);

      return _super.apply(this, arguments);
    }

    _createClass(Displaced, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        this.container = function () {
          var renderTo = options.renderTo;

          if (!renderTo) {
            var result = document.createElement("div");
            document.body.appendChild(result);
            return result;
          } else if (typeof renderTo === "string") {
            var el = document.querySelector(renderTo);

            if (!el) {
              throw new Error("No element matches \"".concat(renderTo, "\"!"));
            }

            return el;
          } else {
            return renderTo;
          }
        }();

        this.forceUpdate();
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        if (!options.renderTo && this.container && this.container.parentNode) {
          this.container.parentNode.removeChild(this.container);
        }
      }
    }, {
      key: "render",
      value: function render() {
        if (this.props.mounted === false) return null;

        if (this.container) {
          return ReactDOM.createPortal(React.createElement(WrappedComponent, this.props, this.props.children), this.container);
        }

        return false;
      }
    }]);

    return Displaced;
  }(React.Component);

  return Displaced;
}